import React from 'react';
import sty from './Header.module.css';
const Header = () => {
  return (
    <header className={sty.header}>
      <h3>ST</h3>
    </header>
  );
};

export default Header;
